import { Stack, styled } from "@mui/material";
import {
  GiftIcon,
  MdShieldIcon,
  ReloadIcon,
  ThinCircleCheckIcon,
  ThunderIcon,
} from "Assets/icons";
import { LgTextSemiBold, Text } from "Components";
import { ALink } from "Components/link";
import { COLORS } from "constants/layout";
import { SVGProps, useState } from "react";
import { useIntl } from "react-intl";

type StatisticType = {
  title: string;
  desc: string[];
  icon: (props: SVGProps<SVGSVGElement>) => JSX.Element;
  href?: string;
};

const BuyerBenefits = () => {
  const t = useIntl();
  const [statistics] = useState<StatisticType[]>([
    {
      title: "join_for_free",
      desc: ["free_register", "post_unlimited_rfqs", "access_premium_sourcing"],
      icon: MdShieldIcon,
      href: "https://freshdi.com/register?direct-url=aHR0cHM6Ly9mcmVzaGRpLmNvbS8=",
    },
    {
      title: "easily_find_verified_suppliers",
      desc: [
        "send_inquiries",
        "free_contact_send_biz_mess",
        "buyer_benefit_desc_2_3",
      ],
      icon: ThinCircleCheckIcon,
      href: "https://freshdi.com/suppliers",
    },
    {
      title: "buyer_benefit_tit_3",
      desc: [
        "buyer_benefit_desc_3_1",
        "buyer_benefit_desc_3_2",
        "buyer_benefit_desc_3_3",
      ],
      icon: ReloadIcon,
      href: "https://sourcing.freshdi.com/buyleads ",
    },
  ]);

  return (
    <StyledStatistics>
      <Stack spacing={{ xs: 0, md: 2 }} direction={{ xs: "column", md: "row" }}>
        {statistics.map((statistic, i: number) => (
          <Stack spacing={{ xs: 1, md: 2 }} key={i} flex={1} className="box">
            <statistic.icon strokeWidth={3.3} stroke="var(--green-500)" />
            <ALink href={statistic.href}>
              <LgTextSemiBold className="value">
                {t.formatMessage({ id: statistic.title })}
              </LgTextSemiBold>
            </ALink>
            <ul>
              {statistic.desc.map((desc, i) => (
                <li key={i}>
                  <Text className="label">{t.formatMessage({ id: desc })}</Text>
                </li>
              ))}
            </ul>
          </Stack>
        ))}
      </Stack>
    </StyledStatistics>
  );
};

const SupplierBenefits = () => {
  const t = useIntl();
  const [statistics] = useState<StatisticType[]>([
    {
      title: "supplier_benefit_title_1",
      desc: [
        "supplier_benefit_desc_1_1",
        "supplier_benefit_desc_1_2",
        "supplier_benefit_desc_1_3",
      ],
      icon: MdShieldIcon,
      href: "https://freshdi.com/register?direct-url=aHR0cHM6Ly9zb3VyY2luZy5mcmVzaGRpLmNvbS9zb3VyY2luZy1yZXF1ZXN0cw==",
    },
    {
      title: "supplier_benefit_title_2",
      desc: [
        "supplier_benefit_desc_2_1",
        "supplier_benefit_desc_2_2",
        "supplier_benefit_desc_2_3",
      ],
      icon: GiftIcon,
      href: "https://intro.freshdi.com/membership/membership-for-supplier",
    },
    {
      title: "supplier_benefit_title_3",
      desc: [
        "supplier_benefit_desc_3_1",
        "supplier_benefit_desc_3_2",
        "supplier_benefit_desc_3_3",
      ],
      icon: ThunderIcon,
      href: "https://sourcing.freshdi.com/buyleads",
    },
  ]);

  return (
    <StyledStatistics>
      <Stack spacing={{ xs: 0, md: 2 }} direction={{ xs: "column", md: "row" }}>
        {statistics.map((statistic, i: number) => (
          <Stack spacing={{ xs: 1, md: 2 }} key={i} flex={1} className="box">
            <statistic.icon stroke="var(--green-500)" />
            <ALink href={statistic.href}>
              <LgTextSemiBold className="value">
                {t.formatMessage({ id: statistic.title })}
              </LgTextSemiBold>
            </ALink>
            <ul>
              {statistic.desc.map((desc, i) => (
                <li key={i}>
                  <Text className="label">{t.formatMessage({ id: desc })}</Text>
                </li>
              ))}
            </ul>
          </Stack>
        ))}
      </Stack>
    </StyledStatistics>
  );
};

const StyledStatistics = styled(Stack)(({ theme }) => ({
  // padding: "0 16px",
  ".box": {
    backgroundColor: "#fff",
    padding: 16,
    borderRadius: 8,
    svg: {
      width: 38,
      height: 42,
    },
    a: {
      textDecorationColor: COLORS.green[500],
    },
    "& .value": {
      color: COLORS.green[500],
    },
    "& .label": {
      color: "var(--gray-800)",
    },
    ul: {
      paddingInlineStart: 16,
      li: {
        marginBottom: 8,
      },
    },
  },
  [theme.breakpoints.down("md")]: {
    padding: "0",
    ".box": {
      padding: 8,
      "& .value": {
        // fontSize: 16,
      },
      "& .label": {
        fontSize: 14,
      },
    },
  },
}));

export { SupplierBenefits, BuyerBenefits };
